// A tab opened before a deploy still runs the old build, and asks for code chunks the new
// deploy no longer serves. The lazy page then fails to load. Vite reports that as
// `vite:preloadError`, and one reload fetches the current build. A second failure soon after
// a reload means something else is wrong, so it's left to surface rather than looping.
export const RELOAD_KEY = 'agence_stale_chunk_reload_at';
export const RELOAD_WINDOW_MS = 10_000;

export function handleStaleChunk(event, { storage, reload, now }) {
  let last = null;
  try { last = Number(storage.getItem(RELOAD_KEY)) || null; } catch { /* storage blocked */ }
  if (last !== null && now() - last < RELOAD_WINDOW_MS) return;
  event.preventDefault();
  try { storage.setItem(RELOAD_KEY, String(now())); } catch { /* storage blocked */ }
  reload();
}

export function startStaleChunkReload() {
  window.addEventListener('vite:preloadError', (event) => handleStaleChunk(event, {
    storage: window.sessionStorage,
    reload: () => window.location.reload(),
    now: () => Date.now(),
  }));
}
